import React, { useState, useRef, useEffect } from "react";
import "./TabbedTextBlock.css";
import parse from "html-react-parser";
import { APP_COLORS } from "../../constants/styles";

function TabbedTextBlock({ contents: contentsArray, colors: colorObj }) {
    const tabRefs = useRef([]);
    const indicatorRef = useRef(null);

    const [activeTab, setActiveTab] = useState(contentsArray[0]?.heading);
    const [displayedTab, setDisplayedTab] = useState(contentsArray[0]?.heading);
    const [subContent, setSubContent] = useState(contentsArray[0]?.contents);
    const [contentButtons, setContentButtons] = useState(contentsArray[0]?.content_buttons);
    const [transitioning, setTransitioning] = useState(false);

    useEffect(() => {
        const current = tabRefs.current[contentsArray.findIndex((t) => t.heading === activeTab)];
        if (current && indicatorRef.current) {
            indicatorRef.current.style.width = `${current.offsetWidth}px`;
            indicatorRef.current.style.left = `${current.offsetLeft}px`;
        }
    }, [activeTab, contentsArray]);

    const handleTabChange = (tabKey, tab) => {
        if (tabKey !== activeTab) {
            setActiveTab(tabKey);
            setTransitioning(true); // start fade-out

            setTimeout(() => {
                // after fade-out completes, change the tab and fade in
                setDisplayedTab(tabKey);
                setSubContent(tab.contents);
                setContentButtons(tab.content_buttons);
                setTransitioning(false);
            }, 500); // match fade-leave duration
        }
    };
    return (
        <div className="tab-block-container py-30" style={APP_COLORS(colorObj)}>
            <div className="container">
                <div className="tab-header-wrapper">
                    <div className="tab-header">
                        {contentsArray.map((tab, index) => (
                            <button
                                key={tab.heading}
                                ref={(el) => (tabRefs.current[index] = el)}
                                className={`tab-button ${
                                    activeTab === tab.heading ? "active" : ""
                                }`}
                                onClick={() => handleTabChange(tab.heading, tab)}
                            >
                                {tab.heading}
                            </button>
                        ))}
                        <div className="tab-indicator" ref={indicatorRef} />
                    </div>
                </div>

                <div className="tab-content-wrapper">
                    <div
                        key={displayedTab}
                        className={`tab-content ${
                            transitioning ? "fade-leave-active" : "fade-enter-active"
                        }`}
                    >
                        {subContent.map((v, i) => (
                            <div key={i} className="tab-section">
                                <h2 className="tab-title">{v?.heading}</h2>
                                <div className="tab-body">{parse(v?.body)}</div>
                                {contentButtons.map((btn, i) => (
                                    <button className="tab-cta" key={i}>
                                        {btn?.label}
                                    </button>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TabbedTextBlock;
